module.exports = __webpack_public_path__ + "res/survey.3028fda5d2be7657b80c0114c723b626.webp";